const plans = [
    {
        id: process.env.API_URL.startsWith("http://localhost") ? "price_1Gz3DFKaJqjzvfOK80MiFjIp" : "price_1Gz2r4KaJqjzvfOKdnPFjgKr",
        name: "Free",
        description: "Ideal for experimenting with Glee and for small side projects.",
        price: 0,
        available: true,
        benefits: {
            unlimited: [],
            available: [
                "1 Team Member",
                [ "Private Visibility", "Organization is only visible to you." ],
                [ "Random Organization Code", "A random unique code will be autogenerated for the organization." ],
                "Community Support",
            ],
            unavailable: [],
        },
    },
    {
        id: process.env.API_URL.startsWith("http://localhost") ? "price_1Gz3E7KaJqjzvfOK7m0wTqpe" : "price_1GuzVdKaJqjzvfOKxmYkak6w",
        name: "Hobby",
        description: "Perfect for small scale personal projects and hobby apps.",
        price: 5,
        available: true,
        benefits: {
            prev: "Free",
            unlimited: [
                "Unlimited Users",
            ],
            available: [
                "10 Team Members",
                [ "Public Visibility", "Change visibility of the organization so everyone can see it." ],
                [ "Discord Integration", "Send notification to a Discord channel when a feedback is posted." ],
                [ "~Slack Integration", "Send notification to a Slack channel when a feedback is posted." ],
                [ "Custom Organization Code", "Set custom unique code for the organization." ],
            ],
            unavailable: [],
        },
    },
    {
        id: process.env.API_URL.startsWith("http://localhost") ? "price_1Gz3EhKaJqjzvfOKLTuplguI" : "price_1GuzV2KaJqjzvfOK8ucpT0nG",
        name: "Standard",
        description: "Enhanced features for powering your professional applications.",
        price: 15,
        available: false,
        benefits: {
            prev: "Hobby",
            unlimited: [
            ],
            available: [
                "50 Team Members",
                "Feedback Status",
                "Feedback Categories",
                "GitHub Integration",
                "Custom Subdomain",
            ],
            unavailable: [],
        },
    },
    {
        id: process.env.API_URL.startsWith("http://localhost") ? "price_1Gz3FDKaJqjzvfOK1AjEZ9qM" : "price_1Gz2pZKaJqjzvfOKzus7NuCS",
        name: "Premium",
        description: "Superior features that're most important for your business needs.",
        price: 30,
        available: false,
        benefits: {
            prev: "Standard",
            unlimited: [
            ],
            available: [
                "100 Team Members",
                "Feedback Roadmap",
                "Webhook Integration",
                "Statistics Dashboard",
                "Custom Domain",
            ],
            unavailable: [],
        },
    },
];

const getPlan = (id) => {
    return plans.find(plan => plan.id === id);
};

export {
    plans,
    getPlan,
}
